import React from 'react';

export const useWindowWidth = (defaultValue?: number) => {
  const [windowWidth, setWindowWidth] = React.useState(() => {
    // 默认宽屏
    return typeof defaultValue === 'number' ? defaultValue : 1920;
  });

  React.useEffect(() => {
    const measureWindowWidth = () => {
      setWindowWidth(window.innerWidth);
    };

    measureWindowWidth();

    window.addEventListener('resize', measureWindowWidth, false);

    return () => {
      window.removeEventListener('resize', measureWindowWidth, false);
    };
  }, []);

  return windowWidth;
};
